import React from 'react'
import { Spinner } from 'react-bootstrap'
import { StatCard as StyledStatCard, StatContent, StatIcon, StatInfo } from '../styles'

interface StatCardProps {
  variant: 'primary' | 'info' | 'success' | 'warning' | 'purple'
  icon: React.ReactNode
  value: number | string
  label: string
  isLoading?: boolean
}

export const StatCard: React.FC<StatCardProps> = ({ variant, icon, value, label, isLoading }) => {
  return (
    <StyledStatCard $variant={variant}>
      {isLoading && (
        <div className="loading-overlay">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      <StyledStatCard.Body>
        <StatContent>
          <StatIcon>{icon}</StatIcon>
          <StatInfo>
            <h3>{value}</h3>
            <p>{label}</p>
          </StatInfo>
        </StatContent>
      </StyledStatCard.Body>
    </StyledStatCard>
  )
}
